import { render } from "./AssignServicesToGroupsForm.vue?vue&type=template&id=f417959a"
import script from "./AssignServicesToGroupsForm.vue?vue&type=script&lang=js"
export * from "./AssignServicesToGroupsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__